export default [
  { value: "Um", text: "1 Cartão" },
  { value: "Dois", text: "2 Cartões" },
  { value: "Tres", text: "3 Cartões" },
]